const state = {
  visitedViews: [],
  caseinfoPageId: {},
  menu: [],
}

const mutations = {
  ADD_VISITED_VIEW: (state, view) => {
    if (state.visitedViews.some(v => v.path === view.path)) return
    state.visitedViews.push(view)
  },

  DEL_VISITED_VIEW: (state, view) => {
    for (const [i, v] of state.visitedViews.entries()) {
      if (v.path === view.path) {
        state.visitedViews.splice(i, 1)
        break
      }
    }
  },

  UPDATE_VISITED_VIEW: (state, view) => {
    for (let v of state.visitedViews) {
      if (v.path === view.path) {
        v = Object.assign(v, view)
        break
      }
    }
  },

  SET_CASEINFO_PAGE_ID: (state, caseinfoPageId) => {
    state.caseinfoPageId = caseinfoPageId
  },

  SET_MENU: (state, menu) => {
    state.menu = menu
  },
}
const actions = {
  addView({ dispatch }, view) {
    dispatch('addVisitedView', view)
  },
  addVisitedView({ commit }, view) {
    commit('ADD_VISITED_VIEW', view)
  },
  delView({ dispatch, state }, view) {
    return new Promise(resolve => {
      dispatch('delVisitedView', view)
      resolve({
        visitedViews: [...state.visitedViews],
      })
    })
  },
  delVisitedView({ commit, state }, view) {
    return new Promise(resolve => {
      commit('DEL_VISITED_VIEW', view)
      resolve([...state.visitedViews])
    })
  },
  updateVisitedView({ commit }, view) {
    commit('UPDATE_VISITED_VIEW', view)
  },
  updateVisitedViewCuiji({ state, commit }, views) {
    state.visitedViews = views;
  },
  addCaseinfoId({ state, commit }, info) {
    // Object.assign(state.caseinfoPageId, info)
    commit('SET_CASEINFO_PAGE_ID', {...state.caseinfoPageId, ...info})
  },

  delCaseinfoId({ state, commit }, id) {
    delete state.caseinfoPageId[id]
    commit('SET_CASEINFO_PAGE_ID', state.caseinfoPageId)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tagsView.js